import axios from "./axios"

function search(query) {
    return axios().get("/warehouses-search", {
        params: {
            search: query
        }
    });
}

export default {
    search
}